// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/qos.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  DirectionType,
  directionTypeFromJSON,
  directionTypeToJSON,
  PacketMirroringType,
  packetMirroringTypeFromJSON,
  packetMirroringTypeToJSON,
  Protocol,
  protocolFromJSON,
  protocolToJSON,
} from "./fabric";
import { Annotation } from "./global";
import { IpProbe, Metadata } from "./types";

export const protobufPackage = "models";

/** IpmConfig describes the configuration for user-initiated IPM collection. */
export interface IpmConfig {
  /**
   * The unique identifier of IpmConfig. Identifier is required to update an existing
   * IpmConfig. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of IpmConfig. IpmConfig name is unique, and is case-insensitive. */
  name: string;
  /** A user-defined description of IpmConfig. Description can be up to 2000 characters. */
  description: string;
  /** A set of user-defined labels for searching and locating objects. */
  labels: string[];
  /** A set of annotations to store user-defined data. */
  annotations: Annotation[];
  /** Indicates if IpmConfig is enabled or disabled. */
  enabled: boolean;
  /**
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /**
   * The identifier of Fabric to which this IpmConfig belongs. Fabric identifier
   * is mandatory, and immutable once set.
   */
  fabricId: string;
  /** This specifies the connectivity rule that led to this Ipm config. */
  ruleId: string;
  /** This specifies the target switch group id for this rule */
  ipmTargetGroupId: string;
  /** List of IPs for monitoring sessions (readonly). */
  peers: string[];
  /** Indicates that this switch has been elected as primary switch (IPM). */
  isPrimary: boolean;
}

/** DscpConfig describes the configuration for DSCP or class-of-service (Cos). */
export interface DscpConfig {
  /**
   * The unique identifier of DscpConfig. Identifier is required to update an existing
   * DscpConfig. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of DscpConfig. DscpConfig name is unique, and is case-insensitive. */
  name: string;
  /** A user-defined description of DscpConfig. Description can be up to 2000 characters. */
  description: string;
  /** A set of user-defined labels for searching and locating objects. */
  labels: string[];
  /** A set of annotations to store user-defined data. */
  annotations: Annotation[];
  /** Indicates if DscpConfig is enabled or disabled. */
  enabled: boolean;
  /**
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /**
   * The identifier of Fabric to which this DscpConfig belongs. Fabric identifier
   * is mandatory, and immutable once set.
   */
  fabricId: string;
  /**
   * Defines a range code points.
   * E.g. [1, 3-6, 9]
   */
  codePoints: string[];
  /** The queue or traffic class identifier (0-7). */
  queueId: number;
  /** Enable strict priority for DSCP scheduler. Must not specify DWRR value. */
  strictPriority: boolean;
  /** Enable PFC. */
  pfcEnabled: boolean;
  /** Enable ECN. */
  ecnEnabled: boolean;
  /**
   * DWRR weight value. Must not specify weight for strict priority queues.
   * The value range is 1 - 100.
   */
  dwrr: number;
  /**
   * The value of "committed information rate" for strict priority queue.
   * CIR must be less than the value of PIR. If the value of CIR is <= 100,
   * then it is assumed to be a percentage.
   */
  cir: string;
  /**
   * The value of "peak information rate" for strict priority queue. PIR must
   * be greater than the value of CIR. If the value of PIR is <= 100, then it
   * is assumed to be a percentage.
   */
  pir: string;
}

/** PacketMirroring describes the configuration for port/packet mirroring. */
export interface PacketMirroring {
  /**
   * The unique identifier of PacketMirroring. Identifier is required to update an existing
   * PacketMirroring. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of PacketMirroring. DscpConfig name is unique, and is case-insensitive. */
  name: string;
  /** A user-defined description of PacketMirroring. Description can be up to 2000 characters. */
  description: string;
  /** A set of user-defined labels for searching and locating objects. */
  labels: string[];
  /** A set of annotations to store user-defined data. */
  annotations: Annotation[];
  /** Indicates if PacketMirroring is enabled or disabled. */
  enabled: boolean;
  /**
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /**
   * The identifier of Fabric to which this PacketMirroring belongs. Fabric identifier
   * is mandatory, and immutable once set.
   */
  fabricId: string;
  /** Type of SPAN (SPAN, ERSPAN etc.) */
  type: PacketMirroringType;
  /** Packet mirroring direction type. */
  direction: DirectionType;
  /** The identifier of node where mirroring needs to be enabled on. */
  nodeId: string;
  /** The name of the source network port. */
  sourcePort: string;
  /** The name of target (destination) network port. */
  targetPort: string;
}

/**
 * An IP SLA Configuration encapsulates the configuration and properties of a set of IP probes
 * used to monitor if a remote service is accessible and withdraw routes from the routing table
 * when the service becomes unavailable.
 *
 * INTERNAL
 *
 * IpSlaConfig describes the configuration for IP/SLA.
 */
export interface IpSlaConfig {
  /**
   * The unique identifier of the IP SLA configuration.
   *
   * INTERNAL
   *
   * The unique identifier of IpSlaConfig. Identifier is required to update an existing
   * IpSlaConfig. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The name of the IP SLA configuration.
   *
   * INTERNAL
   *
   * The user-defined name of IpSlaConfig. IpSlaConfig name is unique, and is case-insensitive.
   */
  name: string;
  /**
   * The description is a user-defined field to store notes about the IP SLA configuration.
   *
   * INTERNAL
   *
   * A user-defined description of IpSlaConfig. Description can be up to 2000 characters.
   */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering IP SLA configurations. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the IP SLA configuration.
   */
  annotations: Annotation[];
  /**
   * The enabled state of the IP SLA configuration which indicates if the IP SLA configuration
   * is enabled or disabled.
   */
  enabled: boolean;
  /**
   * A map of attributes related to the lifecycle of the IP SLA configuration.
   *
   * INTERNAL
   *
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this IP SLA configuration belongs to.
   *
   * INTERNAL
   *
   * The identifier of Fabric to which this IpSlaConfig belongs. Fabric identifier
   * is mandatory, and immutable once set.
   */
  fabricId: string;
  /**
   * The unique identifier of the VRF to which this IP SLA configuration is attached to.
   *
   * INTERNAL
   *
   * VRF to which this IP/SLA is attached to. VrfId is mandatory.
   */
  vrfId: string;
  /** The probe frequency in seconds. The minimum value is 2s and maximum is 1 hour. */
  frequency: number;
  /**
   * The probe timeout in seconds. The minimum value is 1s and maximum must be less than
   * the frequency.
   */
  timeout: number;
  /** The number of failed probe tries before IP SLA service withdraws the matching routes. */
  tries: number;
  /** The protocol to be used for all probes (TCP or UDP). */
  proto: Protocol;
  /** The TCP or UDP port number to be used for all probes. */
  port: number;
  /**
   * The IP prefix matching static routes for which this IP SLA configuration is enabled for.
   *
   * INTERNAL
   *
   * The prefix of static routes for which IP/SLA is enabled. The service
   * looks up static routes with matching prefix, and adds them to probes.
   */
  prefix: string;
  /**
   * An optional list of IP SLA probe configurations.
   *
   * INTERNAL
   *
   * An optional list of IP probe objects. If prefix is provided, then this list
   * maybe empty. If user wants to exclude a specific static route from the probes,
   * then user should add that IP address to probes with "Enabled = false".
   */
  probes: IpProbe[];
}

/** ArsConfig describes the configuration for adaptive routing and switching */
export interface ArsConfig {
  /**
   * The unique identifier of ArsConfig. Identifier is required to update an existing
   * ArsConfig. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of ArsConfig. ArsConfig name is unique, and is case-insensitive. */
  name: string;
  /** A user-defined description of ArsConfig. Description can be up to 2000 characters. */
  description: string;
  /** A set of user-defined labels for searching and locating objects. */
  labels: string[];
  /** A set of annotations to store user-defined data. */
  annotations: Annotation[];
  /** Indicates if ArsConfig is enabled or disabled. */
  enabled: boolean;
  /**
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /**
   * The identifier of Fabric to which this ArsConfig belongs. Fabric identifier
   * is mandatory, and immutable once set.
   */
  fabricId: string;
}

function createBaseIpmConfig(): IpmConfig {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    ruleId: "",
    ipmTargetGroupId: "",
    peers: [],
    isPrimary: false,
  };
}

export const IpmConfig: MessageFns<IpmConfig> = {
  encode(message: IpmConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(82).string(message.ruleId);
    }
    if (message.ipmTargetGroupId !== "") {
      writer.uint32(90).string(message.ipmTargetGroupId);
    }
    for (const v of message.peers) {
      writer.uint32(162).string(v!);
    }
    if (message.isPrimary !== false) {
      writer.uint32(168).bool(message.isPrimary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ipmTargetGroupId = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.peers.push(reader.string());
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.isPrimary = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      ipmTargetGroupId: isSet(object.ipmTargetGroupId) ? globalThis.String(object.ipmTargetGroupId) : "",
      peers: globalThis.Array.isArray(object?.peers) ? object.peers.map((e: any) => globalThis.String(e)) : [],
      isPrimary: isSet(object.isPrimary) ? globalThis.Boolean(object.isPrimary) : false,
    };
  },

  toJSON(message: IpmConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.ipmTargetGroupId !== "") {
      obj.ipmTargetGroupId = message.ipmTargetGroupId;
    }
    if (message.peers?.length) {
      obj.peers = message.peers;
    }
    if (message.isPrimary !== false) {
      obj.isPrimary = message.isPrimary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmConfig>, I>>(base?: I): IpmConfig {
    return IpmConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmConfig>, I>>(object: I): IpmConfig {
    const message = createBaseIpmConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.ipmTargetGroupId = object.ipmTargetGroupId ?? "";
    message.peers = object.peers?.map((e) => e) || [];
    message.isPrimary = object.isPrimary ?? false;
    return message;
  },
};

function createBaseDscpConfig(): DscpConfig {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    codePoints: [],
    queueId: 0,
    strictPriority: false,
    pfcEnabled: false,
    ecnEnabled: false,
    dwrr: 0,
    cir: "0",
    pir: "0",
  };
}

export const DscpConfig: MessageFns<DscpConfig> = {
  encode(message: DscpConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    for (const v of message.codePoints) {
      writer.uint32(82).string(v!);
    }
    if (message.queueId !== 0) {
      writer.uint32(88).uint32(message.queueId);
    }
    if (message.strictPriority !== false) {
      writer.uint32(96).bool(message.strictPriority);
    }
    if (message.pfcEnabled !== false) {
      writer.uint32(104).bool(message.pfcEnabled);
    }
    if (message.ecnEnabled !== false) {
      writer.uint32(112).bool(message.ecnEnabled);
    }
    if (message.dwrr !== 0) {
      writer.uint32(120).uint32(message.dwrr);
    }
    if (message.cir !== "0") {
      writer.uint32(128).int64(message.cir);
    }
    if (message.pir !== "0") {
      writer.uint32(136).int64(message.pir);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DscpConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDscpConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.codePoints.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.queueId = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.strictPriority = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.pfcEnabled = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.ecnEnabled = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.dwrr = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.cir = reader.int64().toString();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.pir = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DscpConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      codePoints: globalThis.Array.isArray(object?.codePoints)
        ? object.codePoints.map((e: any) => globalThis.String(e))
        : [],
      queueId: isSet(object.queueId) ? globalThis.Number(object.queueId) : 0,
      strictPriority: isSet(object.strictPriority) ? globalThis.Boolean(object.strictPriority) : false,
      pfcEnabled: isSet(object.pfcEnabled) ? globalThis.Boolean(object.pfcEnabled) : false,
      ecnEnabled: isSet(object.ecnEnabled) ? globalThis.Boolean(object.ecnEnabled) : false,
      dwrr: isSet(object.dwrr) ? globalThis.Number(object.dwrr) : 0,
      cir: isSet(object.cir) ? globalThis.String(object.cir) : "0",
      pir: isSet(object.pir) ? globalThis.String(object.pir) : "0",
    };
  },

  toJSON(message: DscpConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.codePoints?.length) {
      obj.codePoints = message.codePoints;
    }
    if (message.queueId !== 0) {
      obj.queueId = Math.round(message.queueId);
    }
    if (message.strictPriority !== false) {
      obj.strictPriority = message.strictPriority;
    }
    if (message.pfcEnabled !== false) {
      obj.pfcEnabled = message.pfcEnabled;
    }
    if (message.ecnEnabled !== false) {
      obj.ecnEnabled = message.ecnEnabled;
    }
    if (message.dwrr !== 0) {
      obj.dwrr = Math.round(message.dwrr);
    }
    if (message.cir !== "0") {
      obj.cir = message.cir;
    }
    if (message.pir !== "0") {
      obj.pir = message.pir;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DscpConfig>, I>>(base?: I): DscpConfig {
    return DscpConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DscpConfig>, I>>(object: I): DscpConfig {
    const message = createBaseDscpConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.codePoints = object.codePoints?.map((e) => e) || [];
    message.queueId = object.queueId ?? 0;
    message.strictPriority = object.strictPriority ?? false;
    message.pfcEnabled = object.pfcEnabled ?? false;
    message.ecnEnabled = object.ecnEnabled ?? false;
    message.dwrr = object.dwrr ?? 0;
    message.cir = object.cir ?? "0";
    message.pir = object.pir ?? "0";
    return message;
  },
};

function createBasePacketMirroring(): PacketMirroring {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    type: 0,
    direction: 0,
    nodeId: "",
    sourcePort: "",
    targetPort: "",
  };
}

export const PacketMirroring: MessageFns<PacketMirroring> = {
  encode(message: PacketMirroring, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.type !== 0) {
      writer.uint32(80).int32(message.type);
    }
    if (message.direction !== 0) {
      writer.uint32(88).int32(message.direction);
    }
    if (message.nodeId !== "") {
      writer.uint32(98).string(message.nodeId);
    }
    if (message.sourcePort !== "") {
      writer.uint32(106).string(message.sourcePort);
    }
    if (message.targetPort !== "") {
      writer.uint32(114).string(message.targetPort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PacketMirroring {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketMirroring();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.sourcePort = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.targetPort = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PacketMirroring {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      type: isSet(object.type) ? packetMirroringTypeFromJSON(object.type) : 0,
      direction: isSet(object.direction) ? directionTypeFromJSON(object.direction) : 0,
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      sourcePort: isSet(object.sourcePort) ? globalThis.String(object.sourcePort) : "",
      targetPort: isSet(object.targetPort) ? globalThis.String(object.targetPort) : "",
    };
  },

  toJSON(message: PacketMirroring): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.type !== 0) {
      obj.type = packetMirroringTypeToJSON(message.type);
    }
    if (message.direction !== 0) {
      obj.direction = directionTypeToJSON(message.direction);
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.sourcePort !== "") {
      obj.sourcePort = message.sourcePort;
    }
    if (message.targetPort !== "") {
      obj.targetPort = message.targetPort;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PacketMirroring>, I>>(base?: I): PacketMirroring {
    return PacketMirroring.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PacketMirroring>, I>>(object: I): PacketMirroring {
    const message = createBasePacketMirroring();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.type = object.type ?? 0;
    message.direction = object.direction ?? 0;
    message.nodeId = object.nodeId ?? "";
    message.sourcePort = object.sourcePort ?? "";
    message.targetPort = object.targetPort ?? "";
    return message;
  },
};

function createBaseIpSlaConfig(): IpSlaConfig {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    vrfId: "",
    frequency: 0,
    timeout: 0,
    tries: 0,
    proto: 0,
    port: 0,
    prefix: "",
    probes: [],
  };
}

export const IpSlaConfig: MessageFns<IpSlaConfig> = {
  encode(message: IpSlaConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.vrfId !== "") {
      writer.uint32(82).string(message.vrfId);
    }
    if (message.frequency !== 0) {
      writer.uint32(88).uint32(message.frequency);
    }
    if (message.timeout !== 0) {
      writer.uint32(96).uint32(message.timeout);
    }
    if (message.tries !== 0) {
      writer.uint32(104).uint32(message.tries);
    }
    if (message.proto !== 0) {
      writer.uint32(112).int32(message.proto);
    }
    if (message.port !== 0) {
      writer.uint32(120).uint32(message.port);
    }
    if (message.prefix !== "") {
      writer.uint32(162).string(message.prefix);
    }
    for (const v of message.probes) {
      IpProbe.encode(v!, writer.uint32(170).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpSlaConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpSlaConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.frequency = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.timeout = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.tries = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.proto = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.port = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.probes.push(IpProbe.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpSlaConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      frequency: isSet(object.frequency) ? globalThis.Number(object.frequency) : 0,
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : 0,
      tries: isSet(object.tries) ? globalThis.Number(object.tries) : 0,
      proto: isSet(object.proto) ? protocolFromJSON(object.proto) : 0,
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      probes: globalThis.Array.isArray(object?.probes) ? object.probes.map((e: any) => IpProbe.fromJSON(e)) : [],
    };
  },

  toJSON(message: IpSlaConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.frequency !== 0) {
      obj.frequency = Math.round(message.frequency);
    }
    if (message.timeout !== 0) {
      obj.timeout = Math.round(message.timeout);
    }
    if (message.tries !== 0) {
      obj.tries = Math.round(message.tries);
    }
    if (message.proto !== 0) {
      obj.proto = protocolToJSON(message.proto);
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.probes?.length) {
      obj.probes = message.probes.map((e) => IpProbe.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpSlaConfig>, I>>(base?: I): IpSlaConfig {
    return IpSlaConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpSlaConfig>, I>>(object: I): IpSlaConfig {
    const message = createBaseIpSlaConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.vrfId = object.vrfId ?? "";
    message.frequency = object.frequency ?? 0;
    message.timeout = object.timeout ?? 0;
    message.tries = object.tries ?? 0;
    message.proto = object.proto ?? 0;
    message.port = object.port ?? 0;
    message.prefix = object.prefix ?? "";
    message.probes = object.probes?.map((e) => IpProbe.fromPartial(e)) || [];
    return message;
  },
};

function createBaseArsConfig(): ArsConfig {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
  };
}

export const ArsConfig: MessageFns<ArsConfig> = {
  encode(message: ArsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArsConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: ArsConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArsConfig>, I>>(base?: I): ArsConfig {
    return ArsConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArsConfig>, I>>(object: I): ArsConfig {
    const message = createBaseArsConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
